module.exports = __webpack_public_path__ + "static/media/homeIcon.2bff1018.svg";